export const normalizePlate = (plate) => (
  String(plate || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
);

export const fetchPlateSuggestions = async (plates = []) => {
  const uniquePlates = [...new Set(
    plates.map((plate) => normalizePlate(plate)).filter(Boolean)
  )];

  if (uniquePlates.length === 0) {
    return {};
  }

  const token = localStorage.getItem('token');
  const response = await fetch('/api/plates/suggest', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ plates: uniquePlates })
  });

  if (!response.ok) {
    throw new Error('Erro ao buscar sugestões de placa');
  }

  const data = await response.json();
  return data.suggestions || {};
};

export const getSuggestionForPlate = (suggestions, plate) => {
  const key = normalizePlate(plate);
  if (!key) return null;
  return suggestions[key] || null;
};

export const getSuggestionForInfraction = (suggestionsByInfractionId, infractionId) => (
  suggestionsByInfractionId[infractionId] || null
);
